import React, { Component } from "react";
import './OneButtonDialog.scss'
import { Dialog } from "@material-ui/core";
import { withStyles } from '@material-ui/core/styles';
import i18n from "../../i18n";

import { connect } from 'react-redux'

const styles = {
    paper : {
        background  : "none"
    },
};
class OneButtonDialog extends Component {
    render() {
        const {
            onClose,
            open,
            noButton,
            onButtonClick,
            //dialogHeadText,
            dialogBodyText1,
            dialogBodyText2,
            dialogBodyComp,
            dialogButtonText,
            classes
        } = this.props;
        // const what = content[dialogType]
        return (
            <>
                <Dialog
                    fullWidth={this.props.fullWidth}
                    maxWidth={"sm"}
                    open={open}
                    onClose={onClose}
                    classes = {{paper : classes.paper}}
                    PaperProps={{
                        style: {
                            borderRadius: "10px",
                            overflow : "hidden",
                        }
                    }}
                >
                    {/* <div className="closeBtn" onClick={onClose}>
                        <div className="closeBar1" />
                        <div className="closeBar2" />
                    </div> */}
                    <div className="one-button-dialog-container">
                        {/* <h1 className="one-button-dialog-h1">{dialogHeadText || i18n.t("global.alert")}</h1> */}
                        <div className="one-button-dialog-text">
                            {dialogBodyComp ? dialogBodyComp : <></>}
                            {dialogBodyText1 && <div style={{ wordBreak: this.props.lang !== 'jp' ? 'keep-all' : 'break-all' }}>{dialogBodyText1}</div>}
                            {dialogBodyText2 && <div style={{ wordBreak: this.props.lang !== 'jp' ? 'keep-all' : 'break-all' }}>{dialogBodyText2}</div>}
                        </div>
                        <div >
                            {noButton
                                ? null
                                :
                                <div className="one-button-dialog-button">
                                    <span onClick={onButtonClick}>{dialogButtonText || i18n.t("mobile.global.confirm")}</span>
                                </div>
                            }
                        </div>
                    </div>
                </Dialog>
            </>
        );
    }
}

const mapStateToProps = state => ({
    lang: state.langStore.lang
})

export default withStyles(styles)(connect(mapStateToProps, null)(OneButtonDialog));
